// eslint-disable-next-line no-unused-vars
import React from 'react'

const PublicLayout = ({ children }) => children

export default PublicLayout
